/*
|--------------------------------------------------------------------------
| Helpers
|--------------------------------------------------------------------------
|
| All sort of helper functions and data structures go in this file.
| If you find yourself repeating a function or data structure, it
| might be a good idea to export it here, make it a helper
| function and just import it where needed.
*/

/**
 * Array of all US states with name, slug and abbreviation
 *
 */
export const states = [
  { 'name': 'Alabama', 'slug': 'alabama', 'abbr': 'al' },
  { 'name': 'Alaska', 'slug': 'alaska', 'abbr': 'ak' },
  { 'name': 'Arizona', 'slug': 'arizona', 'abbr': 'az' },
  { 'name': 'Arkansas', 'slug': 'arkansas', 'abbr': 'ar' },
  { 'name': 'California', 'slug': 'california', 'abbr': 'ca' },
  { 'name': 'Colorado', 'slug': 'colorado', 'abbr': 'co' },
  { 'name': 'Connecticut', 'slug': 'connecticut', 'abbr': 'ct' },
  { 'name': 'Delaware', 'slug': 'delaware', 'abbr': 'de' },
  { 'name': 'Florida', 'slug': 'florida', 'abbr': 'fl' },
  { 'name': 'Georgia', 'slug': 'georgia', 'abbr': 'ga' },
  { 'name': 'Hawaii', 'slug': 'hawaii', 'abbr': 'hi' },
  { 'name': 'Idaho', 'slug': 'idaho', 'abbr': 'id' },
  { 'name': 'Illinois', 'slug': 'illinois', 'abbr': 'il' },
  { 'name': 'Indiana', 'slug': 'indiana', 'abbr': 'in' },
  { 'name': 'Iowa', 'slug': 'iowa', 'abbr': 'ia' },
  { 'name': 'Kansas', 'slug': 'kansas', 'abbr': 'ks' },
  { 'name': 'Kentucky', 'slug': 'kentucky', 'abbr': 'ky' },
  { 'name': 'Louisiana', 'slug': 'louisiana', 'abbr': 'la' },
  { 'name': 'Maine', 'slug': 'maine', 'abbr': 'me' },
  { 'name': 'Maryland', 'slug': 'maryland', 'abbr': 'md' },
  { 'name': 'Massachusetts', 'slug': 'massachusetts', 'abbr': 'ma' },
  { 'name': 'Michigan', 'slug': 'michigan', 'abbr': 'mi' },
  { 'name': 'Minnesota', 'slug': 'minnesota', 'abbr': 'mn' },
  { 'name': 'Mississippi', 'slug': 'mississippi', 'abbr': 'ms' },
  { 'name': 'Missouri', 'slug': 'missouri', 'abbr': 'mo' },
  { 'name': 'Montana', 'slug': 'montana', 'abbr': 'mt' },
  { 'name': 'Nebraska', 'slug': 'nebraska', 'abbr': 'ne' },
  { 'name': 'Nevada', 'slug': 'nevada', 'abbr': 'nv' },
  { 'name': 'New Hampshire', 'slug': 'new-hampshire', 'abbr': 'nh' },
  { 'name': 'New Jersey', 'slug': 'new-jersey', 'abbr': 'nj' },
  { 'name': 'New Mexico', 'slug': 'new-mexico', 'abbr': 'nm' },
  { 'name': 'New York', 'slug': 'new-york', 'abbr': 'ny' },
  { 'name': 'North Carolina', 'slug': 'north-carolina', 'abbr': 'nc' },
  { 'name': 'North Dakota', 'slug': 'north-dakota', 'abbr': 'nd' },
  { 'name': 'Ohio', 'slug': 'ohio', 'abbr': 'oh' },
  { 'name': 'Oklahoma', 'slug': 'oklahoma', 'abbr': 'ok' },
  { 'name': 'Oregon', 'slug': 'oregon', 'abbr': 'or' },
  { 'name': 'Pennsylvania', 'slug': 'pennsylvania', 'abbr': 'pa' },
  { 'name': 'Rhode Island', 'slug': 'rhode-island', 'abbr': 'ri' },
  { 'name': 'South Carolina', 'slug': 'south-carolina', 'abbr': 'sc' },
  { 'name': 'South Dakota', 'slug': 'south-dakota', 'abbr': 'sd' },
  { 'name': 'Tennessee', 'slug': 'tennessee', 'abbr': 'tn' },
  { 'name': 'Texas', 'slug': 'texas', 'abbr': 'tx' },
  { 'name': 'Utah', 'slug': 'utah', 'abbr': 'ut' },
  { 'name': 'Vermont', 'slug': 'vermont', 'abbr': 'vt' },
  { 'name': 'Virginia', 'slug': 'virginia', 'abbr': 'va' },
  { 'name': 'Washington', 'slug': 'washington', 'abbr': 'wa' },
  { 'name': 'Washington DC', 'slug': 'district-of-columbia', 'abbr': 'dc' },
  { 'name': 'West Virginia', 'slug': 'west-virginia', 'abbr': 'wv' },
  { 'name': 'Wisconsin', 'slug': 'wisconsin', 'abbr': 'wi' },
  { 'name': 'Wyoming', 'slug': 'wyoming', 'abbr': 'wy' },
];

export const ct_links = [
  'bill-of-sale',
  'cross-state-title-transfer',
  'how-to-buy-a-vehicle',
  'how-to-sell-a-vehicle',
  'new-car-title',
  'replace-lost-title',
  'title-transfer',
];

export const vr_links = [
  'boat-registration',
  'car-registration-address-change',
  'car-registration-name-change',
  'custom-vehicle-registration',
  'emissions-testing',
  'license-plates',
  'registration-sticker-not-received',
  'replace-vehicle-registration',
  'sr-22',
  'vehicle-history-reports',
  'vehicle-registration',
  'vehicle-registration-motorcycle',
  'vehicle-registration-renewal',
];

export const cdl_links = [
  'cdl-commercial-drivers-license-application',
  'cdl-commercial-drivers-license-replacement',
  'cdl-driving-records',
  'dot-physicals',
  'renew-a-cdl-commercial-drivers-license',
];

export const mc_links = [
  'apply-motorcycle-license',
  'motorcycle-insurance',
  'motorcycle-manual-handbook',
  'renew-motorcycle-license',
  'replace-motorcycle-license',
];



// WEBPACK FOOTER //
// ./scripts/helpers.js